module.exports = __webpack_public_path__ + "img/矿山banner1.f55de7c5.png";